import(/* webpackMode: "eager", webpackExports: ["Providers"] */ "/vercel/path0/app/providers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AboutUs/banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/AboutUs/meetOurTeam.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/blog-section.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Blog/BlogCard/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Blog/BlogCategory/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Blog/BlogSubscribe/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Blog/CommentSection/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Blog/LatestBlog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Blog/SimilarBlog/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Blog/Subscribe/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ComingSoon2.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/CompaniesNav.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ConfirmAlert/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/ContactUs/ContactForm/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/CottonLogo.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Footer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Home/JobAlert.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Home/JobCard.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Home/RecruitingImageSlider/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Home/TeamMembers.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Home/TestimonialsSection.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Home/WhatSetUsApart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Home/WorkForceRecruiting.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/Navbar/index.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/questions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/theme-switch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/vercel/path0/components/TopLoader/index.tsx");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@heroui/button/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@heroui/image/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["Input"] */ "/vercel/path0/node_modules/@heroui/input/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@heroui/link/dist/index.mjs");
;
import(/* webpackMode: "eager", webpackExports: ["useDisclosure","Modal","ModalContent","ModalHeader","ModalBody"] */ "/vercel/path0/node_modules/@heroui/modal/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/@iconify/react/dist/iconify.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/animate.css/animate.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/aos/dist/aos.css");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/vercel/path0/node_modules/next/font/google/target.css?{\"path\":\"config/fonts.ts\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\",\"display\":\"swap\"}],\"variableName\":\"fontSans\"}");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/vercel/path0/node_modules/react-hot-toast/dist/index.mjs");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/about/about1.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/about/about2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/about/about3.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/about/about4.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/about/about5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/about/about6.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/about/about7.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_1.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_10.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_11.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_12.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_13.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_14.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_15.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_16.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_17.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_18.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_19.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_2.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_20.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_21.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_22.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_23.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_24.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_25.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_26.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_27.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_28.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_29.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_3.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_30.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_31.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_32.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_33.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_34.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_35.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_36.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_37.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_38.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_39.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_4.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_40.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_41.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_42.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_43.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_44.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_45.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_46.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_47.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_48.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_49.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_5.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_50.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_51.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_52.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_53.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_54.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_55.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_56.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_57.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_58.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_59.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_6.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_7.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_8.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/blog/blog_9.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_10.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_11.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_12.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_6.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_7.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_8.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/clients/client_9.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/frames/frame_1.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/frames/frame_2.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/frames/frame_3.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/frames/frame_4.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/frames/frame_5.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_1.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_10.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_11.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_12.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_13.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_14.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_15.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_16.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_17.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_18.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_19.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_2.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_20.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_21.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_22.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_23.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_24.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_25.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_26.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_27.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_28.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_29.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_3.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_30.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_31.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_32.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_33.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_34.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_35.png");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_36.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_37.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_38.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_39.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_4.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_40.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_41.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_42.jpg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_5.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_6.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_7.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_8.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/img/img_9.jpeg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/about_lines/vector_1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/about_lines/vector_2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/about_lines/vector_3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/about_lines/vector_4.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/dots.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/ellipse.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/flower.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/full_logo_white.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/full_logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/green_leaf.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/line.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/logo.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/long_line.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/offering.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/project.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/quotes.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/security.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/send_email.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/sent.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/star.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/stars.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/team.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/text_strip_1.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/text_strip_2.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/text_strip_3.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/tracking.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/public/assets/svg/yellow_leaf.svg");
;
import(/* webpackMode: "eager" */ "/vercel/path0/styles/globals.css");
